<template lang="pug">
v-form(@submit.prevent ref="form")
	
	stations-fields(v-if="!bookingStore.isPostSale || 'booking_change_before_departure' != bookingStore.isPostSale" :show-switch="true")

	h1.tw-text-xl.mb-4(v-if="bookingStore.isPostSale && 'booking_change_before_departure' == bookingStore.isPostSale") {{$t('sale.ticket_form.select_data', 'Selezionare data e/o orario')}}

	div.tw-flex.tw-flex-row.tw-items-center.tw-justify-start.tw-gap-6(class="emd:tw-flex-col")
		date-time-input(
			class="tw-basis-1/4 emd:tw-w-full"
			v-model="bookingStore.searchFilters.startDate"
			:label="$t('form_labels.departure', 'Andata')"
		)
		div(
			v-if='!bookingStore.isRoundTrip'
			class="tw-h-[60px] tw-px-4 tw-cursor-pointer tw-basis-1/4 emd:tw-w-full tw-color-primary-dark tw-flex tw-items-center tw-justify-start tw-gap-2 tw-bg-neutral-200 hover:tw-bg-neutral-300 tw-rounded-lg return-button"
			@click="bookingStore.setRoundTripStatus(true)"
		)
			v-icon(icon="mdi-plus" size="large" color="primary-darken-1")
			span.tw-font-bold.tw-uppercase {{ $t('form_labels.return', 'Ritorno') }}
		date-time-input(
			v-if='bookingStore.isRoundTrip'
			class="tw-basis-1/4 emd:tw-w-full"
			:disabled="!bookingStore.isRoundTrip"
			v-model="bookingStore.searchFilters.returnDate"
			:label="$t('form_labels.return', 'Ritorno')"
			:clearable="true"
			@clear='bookingStore.setRoundTripStatus(false)'
		)
		participants-input(
			class="tw-basis-1/4 emd:tw-w-full"
			:adults="bookingStore.searchFilters.adult"
			:children="bookingStore.searchFilters.children"
			@update:adults="bookingStore.searchFilters.adult = $event"
			@update:children="bookingStore.searchFilters.children = $event"
		)

		div(class='tw-basis-1/4 emd:tw-w-full')
			v-select(
				class="tw-grow-0"
				v-model="bookingStore.searchFilters.filterSolution"
				:items="solutionFilterOptions"
				item-title="label"
				item-value="value"
				single-line
				required
				hide-details
			)
	div.tw-flex.tw-flex-row.tw-items-center.tw-justify-start.tw-gap-4


	teleport(:to="outOfCard" :disabled="!outOfCard")
		div.tw-flex.tw-justify-end.tw-mb-10(class="emd:tw-justify-center")
			v-btn.mr-4.tw-px-12(color="primary-darken-1" :rounded="0" @click="search()") {{$t('common.find', 'CERCA')}}
</template>

<script setup>
import { useBookingStore } from '@/stores/booking';
import { useBookingStepperStore } from '@/stores/booking-stepper';
import StationsFields from "@/sale/components/tab1_search/stations-fields.vue";
import DateTimeInput from '@/common-components/inputs/date-time-input.vue';
import ParticipantsInput from '@/common-components/inputs/participants-input.vue';
import {inject, watch} from "vue";
import {useI18n} from "vue-i18n";
import { ref } from 'vue';
import { useSearchSolutions } from '@/composables/search-solutions';


const {solutionFilterOptions} = useSearchSolutions();
const stepper = useBookingStepperStore();
const bookingStore = useBookingStore();
const i18n = useI18n();
const form = ref();


defineProps(['outOfCard']);


function search(){
	form.value.validate().then(result => {
		if(!result.valid) return;
		stepper.goNext();
	}).catch(e => {
		console.error(e);
	});
}


watch(() => bookingStore.searchFilters.startDate, () => {
	const start = new Date(bookingStore.searchFilters.startDate.toString());
	start.setHours(start.getHours() + 1);
	let returnDate = start;

	if(import.meta.env.DEV) returnDate.setDate(returnDate.getDate() + 1)

	bookingStore.searchFilters.returnDate = returnDate;
});
</script>

<style scoped>
.return-button {
	border: 2px solid #dfdfdf;
	min-height: 56px;
}
</style>